import { Popover, Button, Icon } from '@nimbus-ds/components';
import { EditIcon, EllipsisIcon, ForbiddenIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { OrderInvoiceResponseDto } from '@tiendanube/common';
import InvoiceOperationEnum from '@tiendanube/common/src/enums/InvoiceOperation';
import Stack from 'commons/components/Stack';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface OptionInvoicePopoverProps {
  onOpenModal: (
    operation: InvoiceOperationEnum,
    number: string,
    reason?: string,
  ) => void;
  invoice: OrderInvoiceResponseDto;
  t: ReturnType<typeof useTranslationOrders>;
}

function OptionInvoicePopover({
  onOpenModal,
  invoice,
  t,
}: Readonly<OptionInvoicePopoverProps>): JSX.Element {
  return (
    <Popover
      id={`${invoice.id}-option-popover`}
      position="bottom-start"
      padding="small"
      arrow={false}
      enabledClick
      content={
        <Stack column spacing="tight" align="flex-start">
          <MenuButton
            label={t(`cardInvoice.button.options.edit`)}
            startIcon={EditIcon}
            onClick={() =>
              onOpenModal(
                InvoiceOperationEnum.CORRECTION,
                invoice.invoice_number,
                invoice.last_correction_event?.reason,
              )
            }
          />

          <MenuButton
            label={t(`cardInvoice.button.options.cancel`)}
            startIcon={ForbiddenIcon}
            onClick={() =>
              onOpenModal(
                InvoiceOperationEnum.CANCELLATION,
                invoice.invoice_number,
              )
            }
          />
        </Stack>
      }
    >
      <Button appearance="neutral">
        <Icon source={<EllipsisIcon />} color="primary-textLow" />
        {t('cardInvoice.button.options.title')}
      </Button>
    </Popover>
  );
}

export default OptionInvoicePopover;
